import React, { useState, useCallback } from "react"
import { Alert, Box, Container, Tab, Tabs, Typography } from "@mui/material"
import SharedFilters, {
    SharedFilterValues,
    todayISO,
} from "../components/exports/SharedFilters"
import SalesJournalTab from "../components/exports/SalesJournalTab"
import CollectionsTab from "../components/exports/CollectionsTab"
import VATBreakdownTab from "../components/exports/VATBreakdownTab"
import RevenueByCategoryTab from "../components/exports/RevenueByCategoryTab"
import FactureXTab from "../components/exports/FactureXTab"
import TicketZTab from "../components/exports/TicketZTab"
import DocumentsTab from "../components/exports/DocumentsTab"
import AuditsTab from "../components/exports/AuditsTab"
import { useCompanyId } from "../hooks/useCompanyId"
import { useTranslation } from "react-i18next"

const ExportsDocumentsPage: React.FC = () => {
    const { t } = useTranslation()
    const { companyId } = useCompanyId()
    const [activeTab, setActiveTab] = useState(0)
    const [filters, setFilters] = useState<SharedFilterValues>({
        outletId: "",
        registerId: "",
        dateFrom: todayISO(),
        dateTo: todayISO(),
    })

    const [dateError, setDateError] = useState<string | null>(null)
    const handleDateError = useCallback(
        (error: string | null) => setDateError(error),
        []
    )

    const tabLabels = [
        t("exportsDocumentsPage.tabs.documents"),
        t("exportsDocumentsPage.tabs.salesJournal"),
        t("exportsDocumentsPage.tabs.collections"),
        t("exportsDocumentsPage.tabs.vatBreakdown"),
        t("exportsDocumentsPage.tabs.revenueByCategory"),
        t("exportsDocumentsPage.tabs.ticketZ"),
        "Audits",
    ]

    const tabProps = { filters, companyId: companyId || "" }

    return (
        <Container maxWidth="xl">
            <Box sx={{ my: 3 }}>
                <Typography variant="h4" gutterBottom>
                    {t("exportsDocumentsPage.title")}
                </Typography>

                <SharedFilters
                    filters={filters}
                    onFiltersChange={setFilters}
                    onDateError={handleDateError}
                />

                <Tabs
                    value={activeTab}
                    onChange={(_e, v) => setActiveTab(v)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
                >
                    {tabLabels.map((label) => (
                        <Tab key={label} label={label} />
                    ))}
                </Tabs>

                <Box sx={{ mt: 1 }}>
                    {dateError ? (
                        <Alert severity="error">{dateError}</Alert>
                    ) : (
                        <>
                            {activeTab === 0 && <DocumentsTab {...tabProps} />}
                            {activeTab === 1 && (
                                <SalesJournalTab {...tabProps} />
                            )}
                            {activeTab === 2 && (
                                <CollectionsTab {...tabProps} />
                            )}
                            {activeTab === 3 && (
                                <VATBreakdownTab {...tabProps} />
                            )}
                            {activeTab === 4 && (
                                <RevenueByCategoryTab {...tabProps} />
                            )}
                            {activeTab === 5 && <TicketZTab {...tabProps} />}
                            {activeTab === 6 && (
                                <AuditsTab companyId={companyId || ""} />
                            )}
                            {/* Facture X kept in code but hidden from tabs */}
                            {false && <FactureXTab {...tabProps} />}
                        </>
                    )}
                </Box>
            </Box>
        </Container>
    )
}

export default ExportsDocumentsPage
